import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple} from '@fuse';
import { Chip, Paper, Grid, Button, SwipeableDrawer, MenuItem, FormControl, InputLabel, Select, OutlinedInput, Divider, TextField, Typography, List, ListItem, ListItemText, ListItemIcon } from '@material-ui/core';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

import HomeIcon from '@material-ui/icons/Home';
import ArrowRightIcon from '@material-ui/icons/ArrowRightOutlined';
import TransformIcon from '@material-ui/icons/Autorenew';
import InfoIcon from '@material-ui/icons/Info';

const styles = theme => ({
    layoutRoot: {},
    PaperUtama: {
        borderRadius: '0px'
    }
});

class TukarPengguna extends Component {
    state = {
        error: null,
        isLoaded: false,
        namaPengguna: 'Khalid',
        bottom: false,
        ListMenu: null,
        email: null,
        selectJenisResponden: 53,
        selectPengggunaId: '',
        routeParams: {
            limit: 20,
            tahun: localStorage.getItem('tahun'),
            sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id
        },
        rows: {}
    }

    goTolink = (url) => {
        this.props.history.push(url);
        // alert('oke ganti');
    }

    onSubmit = (model) => {
        console.info('submit', model);
    }

    rollbackOps = () => {
        this.setState({
            ...this.state,
            routeParams: {
                ...this.state.routeParams,
                // email: localStorage.getItem('email_ops'),
                pengguna_id: localStorage.getItem('pengguna_id_ops')
            }
        }, () => {
            this.props.tukarPengguna(this.state.routeParams).then((result)=>{
                // console.log(this.props.hasil_tukar_pengguna.token);
                localStorage.setItem('jwt_token', this.props.hasil_tukar_pengguna.token);
                localStorage.setItem('perlu_reload_lagi', "1");
                
                window.location.href=localStorage.getItem('root_base');
                // window.location.reload(true);
            });
        });
    }

    componentDidMount = () => {
        this.props.setJudul('Tukar Pengguna');

        // const user = JSON.parse(localStorage.getItem('user'));
        // console.log(this.props.pengguna.rows);
        this.props.setLoading('block');
        this.setState({
            ...this.state,
            routeParams: {
                ...this.state.routeParams,
                pengguna_id: null,
                peran: 53,
                token: localStorage.getItem('jwt_token')
            }
        },()=>{

            this.props.getPengguna(this.state.routeParams).then((result)=>{
                // console.log(result);
                this.props.setLoading('none');
            });
        })
    }

    bukaMenuUtama = () => {
        this.setState({ 
            ...this.state, 
            bottom: true
        });
    }

    toggleDrawer = (side, open, option) => () => {
        this.setState({ ...this.state, [side]: open });
    }

    onChangePengguna = (event) => {
        this.props.setLoading('block');
        this.setState({
            ...this.state,
            selectPengggunaId: event.target.value,
            routeParams: {
                ...this.state.routeParams,
                keyword: event.target.value 
            }
        },()=>{
            this.props.getPengguna(this.state.routeParams).then((result)=>{
                // console.log(result);
                this.props.setLoading('none');
            });
        });
    }

    onClickTukarPengguna = (email) => (event) => {
        // alert(email);
        this.props.setLoading('block');

        this.setState({
            ...this.state,
            routeParams: {
                ...this.state.routeParams,
                email: email,
                sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id
            }
        }, () => {
            if(localStorage.getItem('aslinya_ops') !== "1"){
                localStorage.setItem('pengguna_id_ops', JSON.parse(localStorage.getItem('user')).pengguna_id);
                localStorage.setItem('email_ops', JSON.parse(localStorage.getItem('user')).email);
            }

            this.props.tukarPengguna(this.state.routeParams).then((result)=>{
                // console.log(this.props.hasil_tukar_pengguna.token);
                localStorage.setItem('jwt_token', this.props.hasil_tukar_pengguna.token);
                localStorage.setItem('aslinya_ops', "1");
                localStorage.setItem('perlu_reload_lagi', "1");

                window.location.href="/";
                // window.location.reload(true);
            });
        });

    }

    onChangeJenisResponden = (event) => {
        // console.log(event.target.value);
        this.props.setLoading('block');

        this.setState({
            ...this.state,
            selectJenisResponden: event.target.value,
            routeParams: {
                ...this.state.routeParams,
                pengguna_id: null,
                peran: event.target.value,
                token: localStorage.getItem('jwt_token')
            }
        },()=>{
            // this.setState({
            //     ...this.state,
            //     routeParams: {
            //         ...this.state.routeParams,
            //         pengguna_id: null,
            //         peran: 53,
            //         token: localStorage.getItem('jwt_token')
            //     }
            // },()=>{
            this.props.getPengguna(this.state.routeParams).then((result)=>{
                // console.log(result);
                this.props.setLoading('none');
            });
            // })
        });
    }

    render()
    {
        const {classes} = this.props;
        const {bottom, ListMenu} = this.state;

        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                content={
                    <div style={{width: '100%'}} className="konten-utama">
                        
                        {/* <div className="p-16" style={{border: '0px solid #ccc', width: '100%', background: 'url(assets/images/backgrounds/pencil-book.jpg)', marginTop: '-1px', backgroundPosition: 'center', backgroundSize: 'cover', minHeight: 130}}> */}
                        {localStorage.getItem('aslinya_ops') === '1' &&
                        <div className="p-16" style={{border: '0px solid #ccc', width: '100%', background: 'url(http://'+window.location.host+'/assets/images/backgrounds/kemajuan.png)', marginTop: '-1px', backgroundPosition: 'bottom', backgroundSize: 'cover', minHeight: 89}}>
                            <Grid container spacing={16}>
                                {/* <Grid item xs={12} sm={8} style={{paddingLeft: 10}}>
                                    <h1 style={{fontSize: 25, fontFamily: 'Helvetica', color: 'white'}}>Tukar Pengguna PMP</h1>
                                </Grid> */}
                                <Grid item xs={12} sm={12} style={{paddingLeft: 10, textAlign: 'right'}}>
                                    <Button variant="contained" color="secondary" onClick={this.rollbackOps}>
                                        <TransformIcon/>&nbsp;&nbsp;
                                        Kembali menjadi Kepsek
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>
                        }
                        {/* </div> */}

                        <div style={{minHeight: 10, width: '100%', background: '#4EBBE8', overflow: 'auto', maxHeight: '42px', display: 'inline-flex'}}>
                            <Chip
                                icon={<HomeIcon/>}
                                label=""
                                className={this.props.classes.chip}
                                color="primary"
                                style={{justifyContent: 'start', marginLeft: 0, padding: 5, borderRadius: 0, borderRight: '1px solid #ccc', paddingLeft: '0px', paddingRight: '0px'}}
                                onClick={()=>{this.goTolink('/Beranda')}}
                                />
                            <Chip
                                label="> Tukar Pengguna"
                                className={this.props.classes.chip}
                                color="secondary"
                                // onClick={()=>{this.goTolink('/ManajemenPengguna')}}
                                style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                            />
                        </div>
                        <Paper className={"p-16 " + classes.PaperUtama}>
                            <Paper className="p-16" style={{background: '#F1F8E9'}}>
                                <Grid container>
                                    <Grid item xs={12} sm={1}>
                                        <InfoIcon style={{fontSize:35, color: '#9CCC65'}}/>
                                    </Grid>
                                    <Grid item xs={12} sm={11}>
                                        <Typography variant="caption">
                                            Semua daftar guru yang ditampilkan pada form dibawah ini bersumber dari Data Pokok Pendidikan (Dapodik). 
                                            <br/>Silakan lakukan penyesuaian pada aplikasi Dapodik sekolah Anda apabila ada ketidaksesuaian pada menu "Pengaturan" - "Manajemen Pengguna"
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Paper>
                            <br/>
                            <FormControl variant="outlined" className={classes.formControl} style={{width: '100%', marginBottom: 10}}>
                                <InputLabel
                                    ref={ref => {this.InputLabelRef = ref;}}
                                    htmlFor="outlined-jenis_responden_id-simple"
                                >
                                    Jenis Responden
                                </InputLabel>
                                <Select
                                    value={this.state.selectJenisResponden}
                                    onChange={this.onChangeJenisResponden}
                                    input={
                                    <OutlinedInput
                                        labelWidth={130}
                                        name="jenis_responden_id"
                                        id="outlined-jenis_responden_id-simple"
                                    />
                                    }
                                >
                                    <MenuItem value={53}>Guru</MenuItem>
                                    {/* <MenuItem value={90}>Peserta Didik</MenuItem>
                                    <MenuItem value={14}>Komite</MenuItem> */}
                                </Select>
                            </FormControl>
                            <TextField
                                id="pengguna_id"
                                label="Nama Pengguna"
                                defaultValue={this.state.selectPengggunaId}
                                className={classes.textField}
                                margin="normal"
                                style={{width: "100%"}}
                                variant="outlined"
                                onChange={this.onChangePengguna}
                            />

                            <br/>
                            <br/>
                            <Typography variant="title">
                                Daftar Pengguna
                            </Typography>
                            <Typography variant="caption">
                                Menampilkan 20 hasil teratas (cari menggunakan nama untuk hasil yang lebih akurat)
                            </Typography>
                            <Divider/>
                            <br/>
                            <Paper>
                                {this.props.pengguna.hasOwnProperty('rows') && 
                                <List component="nav">
                                    {this.props.pengguna.rows.map((option)=>{
                                        return (
                                            <ListItem button style={{borderBottom: '1px solid #eee'}} onClick={this.onClickTukarPengguna(option.email)}>
                                                {option.bidang_studi_id_str &&
                                                <ListItemText primary={option.nama + " ("+option.email+")"} secondary={option.peran + " - " + option.bidang_studi_id_str}/>
                                                }
                                                {!option.bidang_studi_id_str &&
                                                <ListItemText primary={option.nama + " ("+option.email+")"} secondary={option.peran}/>
                                                }
                                                <ListItemIcon>
                                                    <ArrowRightIcon/>
                                                </ListItemIcon>
                                           </ListItem>
                                        )
                                    })}
                                </List>
                                }
                            </Paper>
                            {/* <FormControl variant="outlined" className={classes.formControl} style={{width: '100%'}}>
                                <InputLabel
                                    ref={ref => {this.InputLabelRef = ref;}}
                                    htmlFor="outlined-pengguna_id-simple"
                                >
                                    Pilih Pengguna (Guru/Siswa)
                                </InputLabel>
                                <Select
                                    value={this.state.selectPengggunaId}
                                    onChange={this.onChangePengguna}
                                    input={
                                    <OutlinedInput
                                        labelWidth={200}
                                        name="pengguna_id"
                                        id="outlined-pengguna_id-simple"
                                    />
                                    }
                                >
                                    <TextField
                                    id="standard-uncontrolled"
                                    label="Uncontrolled"
                                    defaultValue="foo"
                                    className={classes.textField}
                                    margin="normal"
                                    style={{width: 100}}
                                    />
                                    {this.props.pengguna.rows.map((option)=>{
                                        return (<MenuItem value={option.pengguna_id}>{option.nama} ({option.email})</MenuItem>)
                                    })}
                                </Select>
                            </FormControl> */}
                            {/* <Formsy
                                onValidSubmit={this.onSubmit}
                                ref={(form) => this.form = form}
                                className="flex flex-col justify-center"
                            >
                                <SelectFormsy
                                    className="my-16"
                                    name="related"
                                    label="Jenis Responden"
                                    variant="outlined"
                                    value={this.state.selectJenisResponden}
                                    onChange={()=>alert('nendang')}
                                >
                                    <MenuItem value={53}>Guru</MenuItem>
                                    <MenuItem value={12}>Siswa</MenuItem>
                                </SelectFormsy>

                                <SelectFormsy
                                    className="my-16"
                                    name="related"
                                    label="Pilih Pengguna (Guru/Siswa)"
                                    variant="outlined"
                                    value={this.state.selectPengggunaId}
                                >
                                    <MenuItem value="0">
                                        <em>-</em>
                                    </MenuItem>
                                    <MenuItem value="hai">Hai</MenuItem>
                                    <MenuItem value="olivier">Olivier</MenuItem>
                                    <MenuItem value="kevin">Kevin</MenuItem>
                                </SelectFormsy>

                            </Formsy> */}

                        </Paper>
                        <SwipeableDrawer
                            anchor="bottom"
                            open={bottom}
                            onClose={this.toggleDrawer('bottom', false, null)}
                            onOpen={this.toggleDrawer('bottom', true, null)}
                        >
                            <div style={{padding: 0, minHeight: 100, maxHeight: 400, overflow: 'auto'}}>
                                {ListMenu}
                            </div>
                        </SwipeableDrawer>
                    </div>
                }
            />
        )
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getPengguna: Actions.getPengguna,
        tukarPengguna: Actions.tukarPengguna,
        setLoading: Actions.setLoading,
        setJudul: Actions.setJudul
    }, dispatch);
}

function mapStateToProps({ Pengguna, App }) {

    return {
        pengguna: Pengguna.pengguna,
        hasil_tukar_pengguna: Pengguna.hasil_tukar_pengguna,
        loading: App.loading
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(TukarPengguna)));

// export default withStyles(styles, {withTheme: true})(TukarPengguna);


// WEBPACK FOOTER //
// ./src/main/content/Pengaturan/TukarPengguna.js